import { Typography, Link } from '@mui/material';
import type { InvoicesSyncAttemptResult } from '@weft/api-definition';
import { useVyNavigate } from '../../../../hooks/use-vy-navigate';

export type CustomerNotSyncedNetsuiteWarningProps = {
  failedAttempt: InvoicesSyncAttemptResult
};

export const CustomerNotSyncedNetsuiteWarning: React.FC<CustomerNotSyncedNetsuiteWarningProps> = ({ failedAttempt }) => {
  const navigate = useVyNavigate();

  const handleCustomerClick = () => {
    navigate(`/customers/${failedAttempt.customerId}/settings`);
  };

  return (
    <Typography>
      Customer
      <Link
        href={`/customers/${failedAttempt.customerId}/settings`}
        onClick={handleCustomerClick}
        sx={{
          cursor: 'pointer',
          mx: 1,
        }}
      >
        {failedAttempt.customerName}
      </Link>
      not synced.
    </Typography>
  );
};